import { FormField, FormGrid, Text } from '@dixa/lib-shared-habla';
import { OAuthSettings } from 'lib-integrations-partner-support';
import { config } from 'lib-shared-backend-config';

import { AppLink } from 'components/appLink/appLink';

type ThirdPartyIntegrationAuthorizationProps = {
  integrationId: string;
  integrationType: string;
};

/**
 * The step shown right after an integration that authenticates through OAuth
 * has been created, so the user can authorize it before leaving the modal.
 *
 * @param integrationId - The id of the integration that has just been created.
 * @param integrationType - The type of the integration.
 */
export const ThirdPartyIntegrationAuthorization = ({
  integrationId,
  integrationType,
}: ThirdPartyIntegrationAuthorizationProps): JSX.Element => (
  <FormGrid>
    <FormField>
      <Text.Paragraph>
        The integration has been created. Authorize it so that actions can be
        run with it. You can also authorize it later from the{' '}
        <AppLink
          path="/settings/integrations/partner-widget/:type/:id"
          params={{
            path: { type: integrationType.toLowerCase(), id: integrationId },
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          integration settings
        </AppLink>
        .
      </Text.Paragraph>
    </FormField>

    <OAuthSettings
      configuration={{ baseUrl: config.url.partnerIntegrations }}
      integrationId={integrationId}
      integrationType={integrationType}
      label="Authorize with OAuth"
    />
  </FormGrid>
);
